/*
 * @Author: your name
 * @Date: 2021-07-09 09:38:54
 * @LastEditTime: 2022-01-12 10:32:21
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\store\index.js
 */
import { createStore } from "vuex";
const modulesFiles = require.context("./modules/", true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules
});
